/**
 * SQL Studio bridge URL.
 *
 * Local:  http://localhost:5055
 * Live:   /sql-bridge  (same domain — Apache proxies to Node on 127.0.0.1:5055)
 * Override: REACT_APP_SQL_API_URL
 */
function resolveSqlApiUrl() {
  const fromEnv = process.env.REACT_APP_SQL_API_URL;
  if (fromEnv && String(fromEnv).trim()) {
    const v = String(fromEnv).trim().replace(/\/$/, "");
    // Absolute or root-relative (/sql-bridge) both OK for axios
    return v;
  }

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const isLocal = host === "localhost" || host === "127.0.0.1";
    if (!isLocal) {
      return "/sql-bridge";
    }
  }

  return "http://localhost:5055";
}

export const SQL_API_URL = resolveSqlApiUrl();

export function isLocalSqlBridgeHost() {
  if (typeof window === "undefined") return true;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}
